export const AUTH_PERSISTENCE_KEY = 'webforms_remember_me';
let pendingPersistence = null;

const safely = (operation, fallback = null) => {
  try {
    return operation();
  } catch {
    return fallback;
  }
};

export const createAuthStorage = ({
  localStorage = globalThis?.localStorage,
  sessionStorage = globalThis?.sessionStorage,
} = {}) => {
  const shouldRemember = () => (
    pendingPersistence
      ?? safely(() => sessionStorage?.getItem(AUTH_PERSISTENCE_KEY), 'true') !== 'false'
  );

  const selectedStorage = () => (shouldRemember() ? localStorage : sessionStorage);

  return {
    getItem(key) {
      return safely(() => selectedStorage()?.getItem(key));
    },
    setItem(key, value) {
      const storage = selectedStorage();
      const alternateStorage = storage === localStorage ? sessionStorage : localStorage;
      safely(() => storage?.setItem(key, value));
      // Keep only one Supabase session copy. Without this, switching from a
      // remembered login to a tab-only login can leave the old local session
      // available for a later browser start.
      safely(() => alternateStorage?.removeItem(key));
    },
    removeItem(key) {
      const storage = selectedStorage();
      const alternateStorage = storage === localStorage ? sessionStorage : localStorage;
      safely(() => storage?.removeItem(key));
      safely(() => alternateStorage?.removeItem(key));
    },
  };
};

export const beginAuthPersistence = (
  rememberMe,
) => {
  pendingPersistence = Boolean(rememberMe);
};

export const completeAuthPersistence = (
  succeeded,
  sessionStorage = globalThis?.sessionStorage,
) => {
  if (succeeded && pendingPersistence !== null) {
    safely(() => sessionStorage?.setItem(
      AUTH_PERSISTENCE_KEY,
      pendingPersistence ? 'true' : 'false',
    ));
  }
  pendingPersistence = null;
};

export const authStorage = createAuthStorage();